import { IconOnly } from "./view.iconOnly.js";
import { TextOnly } from "./view.textOnly.js";
import { TextWithIcon } from "./view.textWithIcon.js";
const COMPONENT_MAP = {
  icon_only: IconOnly,
  text_only: TextOnly,
  text_with_icon: TextWithIcon
};
export {
  COMPONENT_MAP
};
